import {
    DEALERADDEDITDSR_SUCCESS,
    DEALERADDEDITDSR_FAILED,
    RESET_DEALERADDEDITDSR,
    LOADING_DEALERADDEDITDSR,
    NETWORK_ERROR_DEALERADDEDITDSR
} from "../types/index";

import { dealerServices } from "../../config/axios";

const resetDealerAddEditDsrList = () => {
    return { type: RESET_DEALERADDEDITDSR };
};

const dealerAddEditDsr = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDEDITDSR });
    await dealerServices
        .post("addEditDsr", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddEditDsrsuccess(res.data));
                    break;
                default:
                    dispatch(dealerAddEditDsrFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDEDITDSR,
                payload: err
            });
        });
};

function dealerAddEditDsrsuccess(data) {
    return {
        type: DEALERADDEDITDSR_SUCCESS,
        payload: data
    };
}
function dealerAddEditDsrFailed(data) {
    return {
        type: DEALERADDEDITDSR_FAILED,
        payload: data
    };
}

export { resetDealerAddEditDsrList, dealerAddEditDsr }